module.exports = import("https://cdn.jsdelivr.net/npm/docx@8.2.4/build/index.mjs");;